import Page4 from '../../features/ServiciosIntegrales.feature/page4';

export default function ServiciosIntegrales() {
  return (
    <>
      <Page4></Page4>
    </>
  );
}
